export default "__VITE_ASSET__DqRQL9of__"